import { useSyncExternalStore } from 'react';

/**
 * Magasin des trois etats de l'accord joue cote Play : la note qui sonne
 * (playingNote), l'accord actif (activeChordNote) et l'accord affiche pour le
 * motif (displayedChordNote). Hors de l'etat de App : jouer un accord ne doit
 * redessiner que la grille et le manche, pas Learn, You et le reste de l'ecran.
 *
 * Meme patron que le magasin de la lecon : valeurs hors de React, abonnes par
 * useSyncExternalStore, adaptateur fin autour du composant qui affiche.
 */

const EMPTY = { playingNote: null, activeChordNote: null, displayedChordNote: null };

let snapshot = EMPTY;
const listeners = new Set();

// Identites stables : useSyncExternalStore se reabonnerait a chaque rendu sinon.
const subscribe = (listener) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

const getSnapshot = () => snapshot;

/**
 * Publie les champs donnes, les autres gardent leur valeur. Rien n'est notifie
 * si les trois valeurs sont inchangees : l'instantane garde sa reference et
 * aucun abonne ne se rend.
 */
export const publishPlayChord = (patch) => {
  const next = { ...snapshot, ...patch };
  if (next.playingNote === snapshot.playingNote
    && next.activeChordNote === snapshot.activeChordNote
    && next.displayedChordNote === snapshot.displayedChordNote) return;
  snapshot = next;
  listeners.forEach((listener) => listener());
};

// Fonction stable a passer en callback : le player de jam pousse l'accord des
// marqueurs MIDI ici, comme il posait l'etat de App avant.
export const publishActiveChordNote = (note) => publishPlayChord({ activeChordNote: note });

export const clearPlayChord = () => publishPlayChord(EMPTY);

export const readPlayChord = () => snapshot;

export const usePlayChord = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

// Abonnement au seul fait qu'un accord sonne. Enchainer les accords ne change
// pas ce booleen : l'abonne ne se rend qu'au passage silence/son.
const getSounding = () => snapshot.playingNote !== null;

export const useIsChordSounding = () => useSyncExternalStore(subscribe, getSounding, getSounding);
